import { USER_LOGIN } from "../CONSTANTS";

export default function userLogin() {
  return {
    type: USER_LOGIN,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/actions/userLogin.js